import LandingLayout from "layouts/LandingLayout";

/* eslint-disable no-param-reassign */
const withLandingLayout = (Screen) => {
  Screen.Layout = LandingLayout;
  return Screen;
};

export default withLandingLayout;
